import { IGeneralResponse } from '@/api/types'

export interface IPaymentProfileAttributes {
  id?: number
  sid: string
  account_type: string
  account: string
  first_name: string
  last_name: string
  country_code: string
  country_name?: string
  address: string
  company_name: string
  verify: boolean
  verified: boolean
  blocked: boolean
  status?: string
  message?: string
  title: string
}

export const PredefinedFields = [
  'account',
  'first_name',
  'last_name',
  'address',
  'country_code',
  'account_type'
]

export const SystemAccountTitle: Record<string, string> = {
  paypal: 'Payment Account',
  revolut: 'Last 4 card digits'
}

export const SystemAccountHint: Record<string, string> = {
  paypal: 'PayPal payment account (email)',
  revolut: 'Payment card last 4 digits'
}

export interface IPaymentProfile {
  id: string
  type: 'paymentprofile'
  attributes: IPaymentProfileAttributes
}

export interface IPaymentProfileResponse extends IGeneralResponse {
  data: IPaymentProfile
  url: string
}
